import { render } from "./CollectionDetailedSearch.vue?vue&type=template&id=6c398376&scoped=true&ts=true"
import script from "./CollectionDetailedSearch.vue?vue&type=script&lang=ts"
export * from "./CollectionDetailedSearch.vue?vue&type=script&lang=ts"

import "./CollectionDetailedSearch.vue?vue&type=style&index=0&id=6c398376&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src186255619/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c398376"]])

export default __exports__